import { z } from 'zod';
import { positiveDecimal } from './primitives.js';

const code = z.string().trim().regex(/^[A-Z0-9_-]{2,30}$/, { error: 'Code en majuscules (A-Z, 0-9, _ -)' });
const name = z.string().trim().min(2).max(160);

export const tradeSchema = z.object({ kind: z.literal('TRADE'), code, name });
export const crewSchema = z.object({
  kind: z.literal('CREW'),
  code,
  name,
  members: z.array(z.object({ trade: code, count: positiveDecimal })).min(1).max(30),
  note: z.string().max(300).optional(),
});
export const taskSchema = z.object({
  kind: z.literal('TASK'),
  code,
  name,
  unit: z.string().trim().min(1).max(10),
  crew: code.optional(),
  outputPerDay: positiveDecimal.optional(),
  basisOutputKey: z.string().max(40).optional(),
  included: z.boolean().optional(),
  match: z
    .object({
      families: z.array(z.string()).optional(),
      groups: z.array(z.string()).optional(),
      kinds: z.array(z.string()).optional(),
      levelKinds: z.array(z.string()).optional(),
      backfill: z.boolean().optional(),
    })
    .optional(),
  priority: z.number().int().optional(),
});
export const equipmentItemSchema = z.object({
  kind: z.literal('EQUIPMENT'),
  code,
  name,
  category: z.enum(['LOCATION', 'ACHAT', 'TRANSPORT']),
  unit: z.enum(['j', 'h', 'U', 'voyage']),
});
export const laborItemSchema = z.discriminatedUnion('kind', [tradeSchema, crewSchema, taskSchema, equipmentItemSchema]);

/** Ligne de matériel d'un projet. */
export const equipmentLineSchema = z.object({
  equipmentCode: code,
  label: z.string().trim().max(160).nullable().optional(),
  quantity: positiveDecimal.default('1'),
  duration: positiveDecimal.nullable().optional(),
  durationMode: z.enum(['MANUAL', 'FROM_LABOR']).default('MANUAL'),
  taskCodes: z.array(code).max(30).default([]),
  chapterId: z.uuid().nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export const equipmentLineUpdateSchema = equipmentLineSchema.partial().extend({ version: z.number().int().positive() });

export const laborPriceSchema = z.object({
  kind: z.enum(['TRADE', 'TASK', 'EQUIPMENT']),
  code,
  unitPrice: positiveDecimal,
  priceDate: z.iso.date(),
  source: z.enum(['SUPPLIER', 'MANUAL', 'LAST_USED', 'IMPORT']).default('MANUAL'),
  note: z.string().max(1000).nullable().optional(),
});
